import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { RouterFacade } from '~/core/features'
import { EGuardSection } from '~/core/models'

import { HistoricalDataContainerComponent } from './containers'

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrl: './historical-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HistoricalDataContainerComponent],
})
export class HistoricalDataComponent {
  private readonly routerFacade = inject(RouterFacade)

  private readonly isCompanyPage = toSignal(this.routerFacade.isCompanyPage$)

  readonly guardSection = computed(() =>
    this.isCompanyPage() ? EGuardSection.COMPANY_INFO_HISTORY : EGuardSection.FORECAST_INFO_HISTORY
  )

  constructor() {}
}
